namespace $.$$ {
	
	$mol_style_define( $shm_hitalama_map_widget_float_notebook_preview, {
		
		List: {
			gap: $mol_gap.block,
		},
		
	} )
	
}
